import dayjs from 'dayjs';

import type {
  CleanReservationRuleResponse,
  ReservationRuleFormValues,
} from '../../sharedTypes';
import { getCleanKindRulesFormValues } from '../helper';
import type { CleanReservationRuleEditRequest } from './types';

export const canReserveValidator = (args: {
  allValues: ReservationRuleFormValues;
  showErrorMsg: (errorMsg: string) => void;
}) => {
  const { allValues, showErrorMsg } = args;
  const {
    canReserveAfterNumber,
    canReserveAfterUnit,
    canReserveBeforeNumber,
    canReserveBeforeUnit,
  } = allValues;

  if (
    typeof canReserveAfterNumber !== 'number' ||
    !canReserveAfterUnit ||
    typeof canReserveBeforeNumber !== 'number' ||
    !canReserveBeforeUnit
  ) {
    showErrorMsg('請確認是否有未填寫欄位');
    return false;
  }

  const start = dayjs.duration(canReserveAfterNumber, canReserveAfterUnit);
  const end = dayjs.duration(canReserveBeforeNumber, canReserveBeforeUnit);
  const isRangeValid = start.asMilliseconds() < end.asMilliseconds();

  if (isRangeValid === false) {
    showErrorMsg('開始時間不能大於結束時間');
    return false;
  }

  return true;
};

export const formatCleanKindRulesToRequest = (
  id: string,
  formValues: ReservationRuleFormValues
) => {
  const {
    mustCancelBeforeNumber,
    mustCancelBeforeUnit,
    canReserveAfterNumber,
    canReserveAfterUnit,
    canReserveBeforeNumber,
    canReserveBeforeUnit,
    autoPushNotification,
  } = formValues;

  const data: CleanReservationRuleEditRequest = {
    _id: id,
    mustCancelBefore: {
      value: mustCancelBeforeNumber,
      unit: mustCancelBeforeUnit,
    },
    canReserveAfter: {
      value: canReserveAfterNumber,
      unit: canReserveAfterUnit,
    },
    canReserveBefore: {
      value: canReserveBeforeNumber,
      unit: canReserveBeforeUnit,
    },
    autoPushNotification: autoPushNotification.valueOf(),
  };

  return data;
};

export const getTypeCheckedCleanKindRules = (
  cleanKindRules: ReservationRuleFormValues | CleanReservationRuleResponse
) => {
  if (typeof cleanKindRules.autoPushNotification === 'number') {
    const rules = getCleanKindRulesFormValues(
      cleanKindRules as CleanReservationRuleResponse
    );
    return rules;
  }
  return cleanKindRules as ReservationRuleFormValues;
};
